































import mixins from 'vue-typed-mixins';
import vuelidateMixin from "@/mixins/vuelidateMixin";
import { required  } from 'vuelidate/lib/validators';
import {ExtensionViewModel} from "../../models/ExtensionViewModel";
import {EmployeeAssignmentViewModel} from "@/models/EmployeeAssignmentViewModel";
import {AssignedToUserViewModel} from "@/models/AssignedToUserViewModel";
import BoxContainer from "@/components/BoxContainer.vue";

export default mixins( vuelidateMixin ).extend( {
  name: "ExtensionAssignmentPanel",
  components: {
    BoxContainer
  },
  props: {
    extension: {
      type: Object as () => ExtensionViewModel
    }
  },
  data(): {
    userList: AssignedToUserViewModel[]
    employeeAssignment: EmployeeAssignmentViewModel
  }{
    return {
      userList: [] as AssignedToUserViewModel[] ,
      employeeAssignment: {} as EmployeeAssignmentViewModel
    }
  },
  validations: {
    employeeAssignment: {
      userName: {
        required ,
      }
    }
  },
  methods: {
    async getUserList() {

      let result = await this.axios.get('/Lookups/GetExtensionUsers');
      const data = result.data as EmployeeAssignmentViewModel[];

      this.userList = data.sort( function(a:any,b:any ) {
        let nameA = a.fullName.toUpperCase();
        let nameB = b.fullName.toUpperCase();
        if ( nameA < nameB ) {
          return -1;
        }
        if ( nameA > nameB ) {
          return 1;
        }
        return 0;

      });
      console.log("userList");
      console.log(this.userList);
    },
    async handleSubmit() {

      const valid = this.isValidWithNotification( this.$v.employeeAssignment);


      if ( valid ) {

        let tempUser = this.userList.find(u => u.userName === this.employeeAssignment.userName);
        console.log(tempUser);
        if ( tempUser ) {
          this.employeeAssignment.email = tempUser.email;
          this.employeeAssignment.fullName = tempUser.fullName;
          this.employeeAssignment.itemId = this.extension.extensionId;

          console.log(this.employeeAssignment);

          let result = await this.axios.post(
              '/Extensions/UpdateAssignment',
              this.employeeAssignment,
              {headers: {"Content-Type": "application/json"}}
          );

          console.log(result);

          await this.$router.push({name: "extensions-detail", params: {id: this.extension.extensionId.toString()}});
        }

      }

    }
  },
  mounted: async function() {
    await this.getUserList();
  }
} )
